<template>
    <HeroBanner v-bind="bannerDefaults" class="plp-category-header">
        <template #additional_content>
            <div v-if="hasSubcategories" style="z-index: 1;" :class="['category-button-wrapper', rowColumns]">
                <Link as="button" :class="`bg-${props.button_bg_color} border-${props.button_bg_color} text-${props.button_font_color}`"
                    v-for="(childCategory, i) in categoryData.child_category" :key="i" class="category-button"
                    :href="route('category.shop-all', [childCategory.seo_name])" 
                    :aria-label="`Shop all ${childCategory.category_name}`"
                >
                    {{ childCategory?.category_name }}
                </Link>
            </div>
        </template>
    </HeroBanner>
</template>
<script lang="ts" setup>
    import { computed, inject } from "vue";
    import HeroBanner from "@/components/HeroBanner.vue";
    import { Link } from "@inertiajs/vue3"
    import {
        richTextHasText,
        useRichTextFormatting
    } from "@/helpers/composables/builderFieldUtility.ts";
    // import { route } from "ziggy-js";
    let route = inject('route');
    const props = defineProps({
        category: { 
            type: Object 
        },
        button_bg_color: {
            type: String,
            default: 'rothcoBlack'
        },
        button_font_color: {
            type: String,
            default: 'rothcoWhite'
        },
        banner: {
            type: Object,
            required: true
        },
        builderContext: {
            type: Object,   
        }
    })

    const categoryData = computed(() => {
        return props.builderContext?.content?.data?.category ?? props.category ?? {};
    });

    const bannerDefaults = computed(()=>{
        let defaults = {
            banner_media: {
                ...props.banner?.banner_media,
                min_height: hasSubcategories.value || hasBannerImage.value ? '300' : '200',
                max_height: '520',
                bg_color: props.banner?.banner_media?.bg_color ?? 'None'
            },
            banner_content: {
                ...props.banner?.banner_content,
                text_bg_color: 'None',
                content_align_vertical: 'middle',
                content_align_horizontal: 'center'
            },
            eyebrow: {
                text: props.banner?.eyebrow?.text || '',
                color: props.banner?.eyebrow?.color ?? 'rothcoBlack'
            },
            heading: {
                text: (richTextHasText(props.banner?.heading?.text) && props.banner?.heading?.text) || categoryData?.value?.category_name || '',
                color: props.banner?.heading?.color ?? 'rothcoBlack'
            },
        };
        return defaults;
    })

    const hasSubcategories = computed(()=>{
        return categoryData?.value?.child_category?.length > 0;
    })

    const hasBannerImage = computed(()=>{
        return !!props.banner?.banner_media?.desktop_media
    })

    const rowColumns = computed(() => {
        let numChildCategories = categoryData?.value?.child_category.length;
        if(numChildCategories % 5 == 0){
            return 'five'
        } else if(numChildCategories % 4 == 0){
            return 'four'
        } else if(numChildCategories % 3 == 0){
            return 'three'
        } else if(numChildCategories % 2 == 0){
            return 'two'
        } else {
            return 'five'
        }
    })
</script>
